export default "__VITE_ASSET__Ogp2YnDv__"